import React from "react";
import "../../../assets/styles/dischargeSummary.scss";
import rcIcon from '../../../assets/images/image 1.png';
const DischargeSummary = () => {
  return (
    <div className="discharge-summary-print">
      <div className="header">
        <div className="flex gap-2">
          <img src={rcIcon} width="24" height="24"/>
          <div>Vital Impact</div>
        </div>
      </div>
      <div className="subtitle">
        <div className="discharge-button">Discharge Summary</div>
      </div>
      <div className="camp-details">
        <div className="camp-detail-item">
          <span className="description">Details of camp from which patient came for surgery:</span>{" "}
          <span className="value">Vital Impact One</span>
        </div>
        <div className="camp-detail-item">
          <span className="description">Patient name:</span>{" "}
          <span className="value">Lisa Gonzalez</span>
        </div>
      </div>
      <div className="divider"></div>
      <div className="spacing"></div>
      <div className="patient-info">
        <div className="left">
          <div className="description">Patient ID</div>
          <div className="value">56235</div>
        </div>
        <div className="right">
          <div className="description">Patient Aadhaar/Arkyos/Tree/Ration card number</div>
          <div className="value">******5062</div>
        </div>
      </div>
      <div className="spacing"></div>
      <div className="divider"></div>
      <div className="spacing"></div>
      <div className="vital-parameters">
        <div className="spacing"></div>
        <div className="parameter">Patient Vital Parameters</div>
        <div className="spacing"></div>
        <div className="vitals-row">
          <div className="vital-item">
            <div className="label">Blood Pressure</div>
            <div className="value">120/80 mm Hg</div>
          </div>
          <div className="vital-item">
            <div className="label">Blood Sugar</div>
            <div className="value">70-99 mg/dL</div>
          </div>
          <div className="vital-item">
            <div className="label">Age</div>
            <div className="value">38 yrs</div>
          </div>
          <div className="vital-item">
            <div className="label">Height</div>
            <div className="value">178 cm</div>
          </div>
          <div className="vital-item">
            <div className="label">Weight</div>
            <div className="value">68 kg</div>
          </div>
        </div>
      </div>
      <div className="spacing"></div>
      <div className="divider"></div>
      <div className="spacing"></div>
      <div className="summary-sections">
        <div>
          <div className="description">Treatment Summary</div>
          <span className="value">Space to write summary of the treatment done Space to write summary of the treatment one space to write summary of the treatment done Space to Write summary of the treatment done</span>
        </div>
        <div>
          <div className="description">Patient Condition</div>
          <span className="value">Space to write summary of the treatment done Space to write summary of the treatment done Space to write summary of the treatment one space</span>
        </div>
      </div>
      <div className="divider"></div>
      <div className="spacing"></div>
      <div className="summary-sections">
        <div>
          <div className="description">Medicine Details</div>
          <span className="value">Space to write summary of the treatment done</span>
        </div>
        <div>
          <div className="description">Diet</div>
          <span className="value">Space to write summary of the treatment done</span>
        </div>
      </div>
      <div className="divider"></div>
      <div className="note">
        <span className="value">Note:</span> Space to write summary of the treatment done
      </div>
    </div>
  );
};

export default DischargeSummary;
